/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import { getNumberFormatter, styled, t, tn } from '@aibi-ui/core';
import { Tooltip } from 'src/components/Tooltip';

type RowCountLabelProps = {
  rowcount?: number;
  limit?: number;
  loading?: boolean;
};

const StyledDiv = styled.div`
  text-align: center;
  line-height: 22px;
  color: #fff;
  background: #f46565;
  font-size: 12px;
  border-radius: 3px;
  min-width: 36px;
  height: 22px;
  width: fit-content;
  margin-right: 6px;
`;

const limitReachedMsg = '已达到为图表设置的行限制。图表可能显示部分数据。';

export default function RowCountLabel(props: RowCountLabelProps) {
  const { rowcount = 0, limit = null, loading } = props;
  const limitReached = limit && rowcount >= limit;
  const type =
    limitReached || (rowcount === 0 && !loading) ? 'danger' : 'default';
  const formattedRowCount = getNumberFormatter()(rowcount);
  const label = (
    <div>
      {loading ? (
        t('Loading...')
      ) : (
        <span data-test="row-count-label">
          {tn('%s row', '%s rows', rowcount, formattedRowCount)}
        </span>
      )}
    </div>
  );
  return limitReached ? (
    <Tooltip id="tt-rowcount-tooltip" title={<span>{limitReachedMsg}</span>}>
      <StyledDiv>{label}</StyledDiv>
    </Tooltip>
  ) : (
    <StyledDiv>{label}</StyledDiv>
  );
}

export type { RowCountLabelProps };
